import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import type { AcqComponentKey } from "./componentKeys";

/**
 * One lazily loaded page component per record type. App.tsx maps each entry
 * of src/data/acquisition/manifest.ts to <AcqRoute>, so the main bundle carries
 * only the path list; each page's code and copy load with its own chunk.
 */
export type AcqPageProps = { path: string };

export const ACQ_COMPONENTS: Record<AcqComponentKey, LazyExoticComponent<ComponentType<AcqPageProps>>> = {
  hub: lazy(() => import("./HubPage")),
  "cost-calculator": lazy(() => import("./tools/CostCalculatorPage")),
  "missed-call-report": lazy(() => import("./tools/MissedCallReportPage")),
  "setup-simulator": lazy(() => import("./tools/SetupSimulatorPage")),
  "script-builder": lazy(() => import("./tools/ScriptBuilderPage")),
  "after-hours": lazy(() => import("./demos/AfterHoursPage")),
  "follow-a-call": lazy(() => import("./demos/FollowACallPage")),
  "your-business": lazy(() => import("./demos/YourBusinessPage")),
  "demo-question": lazy(() => import("./demos/DemoQuestionPage")),
  challenge: lazy(() => import("./demos/ChallengePage")),
  card: lazy(() => import("./demos/CardPage")),
  guide: lazy(() => import("./guides/GuidePage")),
  "use-case": lazy(() => import("./guides/UseCasePage")),
  "storm-kit": lazy(() => import("./guides/StormKitPage")),
  benchmark: lazy(() => import("./research/BenchmarkPage")),
  "ai-answers": lazy(() => import("./research/AiAnswersPage")),
  partners: lazy(() => import("./programs/PartnersPage")),
  "build-series": lazy(() => import("./programs/BuildSeriesPage")),
  advisors: lazy(() => import("./programs/AdvisorsPage")),
};

export function AcqRoute({ path, component }: { path: string; component: string }) {
  const Page = ACQ_COMPONENTS[component as AcqComponentKey];
  return Page ? <Page path={path} /> : null;
}
